var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_GoalSettings_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_GoalSettings_Delete_Body"
          ),
          brickTitle: _vm.title
        },
        brick: _vm.brick,
        name: _vm.newName,
        invalid: _vm.$v.$invalid || _vm.isLoading || !_vm.customConditionsValid
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.onSave()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        },
        "display-errors": function($event) {
          return _vm.displayErrorMessages()
        }
      }
    },
    [
      _c("settings-item", {
        attrs: {
          icon: "fas fa-plane-arrival",
          label: _vm.resource("JourneyBuilder_GoalSettings_GoalType_Label")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      options: _vm.selectableGoalTypes,
                      disabled:
                        !_vm.canWrite || _vm.selectableGoalTypes.length === 0,
                      clearable: false,
                      searchable: "",
                      filterable: "",
                      taggable: "",
                      "close-on-select": ""
                    },
                    model: {
                      value: _vm.goalTypeModel,
                      callback: function($$v) {
                        _vm.goalTypeModel = $$v
                      },
                      expression: "goalTypeModel"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          },
          {
            key: "errors",
            fn: function() {
              return [
                _vm.$v.goalTypeModel.$dirty && _vm.$v.goalTypeModel.$invalid
                  ? _c("required-error-message", {
                      attrs: {
                        "field-name": _vm.resource(
                          "JourneyBuilder_GoalSettings_GoalType_Label"
                        )
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("settings-item", {
        attrs: {
          label: _vm.resource("JourneyBuilder_GoalSettings_DeleteRecords_Label")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("toggle-button", {
                  attrs: {
                    sync: true,
                    labels: {
                      checked: _vm.resource("Bool_Yes"),
                      unchecked: _vm.resource("Bool_No")
                    },
                    width: 78
                  },
                  model: {
                    value: _vm.settings.deleteRecords,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "deleteRecords", $$v)
                    },
                    expression: "settings.deleteRecords"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.supportsDeleteAfter
        ? [
            _c("div", [
              _c(
                "label",
                { staticClass: "control-label" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.resource(
                          "JourneyBuilder_GoalSettings_DeleteAfter_Label"
                        )
                      ) +
                      "\n\n                "
                  ),
                  _c("help-popover", {
                    attrs: {
                      content: _vm.resource(
                        "JourneyBuilder_GoalSettings_DeleteAfter_Tooltip"
                      )
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("jira-style-time-period", {
              attrs: { disabled: !_vm.canWrite },
              model: {
                value: _vm.settings.deleteAfter,
                callback: function($$v) {
                  _vm.$set(_vm.settings, "deleteAfter", $$v)
                },
                expression: "settings.deleteAfter"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("settings-item", {
            attrs: {
              label: _vm.resource(
                "JourneyBuilder_GoalSettings_AudienceSettings_Title"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("toggle-button", {
                      attrs: {
                        sync: true,
                        labels: {
                          checked: _vm.resource("Bool_Yes"),
                          unchecked: _vm.resource("Bool_No")
                        },
                        width: 78
                      },
                      model: {
                        value: _vm.displayAudienceSettings,
                        callback: function($$v) {
                          _vm.displayAudienceSettings = $$v
                        },
                        expression: "displayAudienceSettings"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.displayAudienceSettings
            ? _c("goal-audience-settings", {
                attrs: {
                  "is-new-audience": _vm.settings.audience.isNew,
                  "new-audience-name": _vm.settings.audience.newAudienceName,
                  "audience-id": _vm.settings.audience.audienceId
                },
                on: {
                  "update:isNewAudience": function($event) {
                    return _vm.$set(_vm.settings.audience, "isNew", $event)
                  },
                  "update:is-new-audience": function($event) {
                    return _vm.$set(_vm.settings.audience, "isNew", $event)
                  },
                  "update:newAudienceName": function($event) {
                    return _vm.$set(
                      _vm.settings.audience,
                      "newAudienceName",
                      $event
                    )
                  },
                  "update:new-audience-name": function($event) {
                    return _vm.$set(
                      _vm.settings.audience,
                      "newAudienceName",
                      $event
                    )
                  },
                  "update:audienceId": function($event) {
                    return _vm.$set(_vm.settings.audience, "audienceId", $event)
                  },
                  "update:audience-id": function($event) {
                    return _vm.$set(_vm.settings.audience, "audienceId", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("goal-custom-conditions", {
        ref: "customConditions",
        attrs: { "goal-type": _vm.goalTypeModel && _vm.goalTypeModel.id },
        on: {
          "loading-state-changed": function($event) {
            _vm.isLoading = $event
          },
          "validation-state-changed": function($event) {
            _vm.customConditionsValid = $event
          }
        },
        model: {
          value: _vm.settings.customConditions,
          callback: function($$v) {
            _vm.$set(_vm.settings, "customConditions", $$v)
          },
          expression: "settings.customConditions"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }